(function () {
	Vue.component('nominow-searchable-menulist', {
		props: {
			items: {
				type: Array,
				required: true,
				default: []
			},
			showKey: {
				type: String,
				required: true
			},
			idKey: {
				type: String,
				required: false,
				default: '_id'
			},
			placeholder: {
				type: String,
				required: false,
				default: 'Search list'
			},
			maxheight: {
				type: Number,
				required: false,
				default: 75
			}
		},
		data: function () {
			return {
				id: 'menu-' + new Date().getTime(),
				cssclass: 'js-list-menu-item-' + new Date().getTime(),
				selectedItem: null,
				filter: null,
				sessionKey: null
			};
		},
		template: `<div>
	<div style="margin:0.5rem 0;">
		<div class="field">
			<div class="control field ">
				<p class="control"><input name="search" :placeholder="placeholder" class="input has-min-width" v-model="filter" type="text" v-on:keyup="filterList"></p>
			</div>
		</div>
	</div>
	<ul class="menu-list" v-if="items != null && items.length > 0" style="overflow-x:hidden;overflow-y:auto;margin-bottom:1rem;" :style="'max-height: ' + maxheight + 'vh;'">
		<li v-for="(elem, i) in items" :class="cssclass">
			<a href="#" v-bind:class="{'is-active': selectedItem != null && elem[idKey] == selectedItem[idKey]}"
				v-on:click.prevent="selectItem(elem, i)">{{elem[showKey] }}</a>
		</li>
	</ul>
</div>`,
		watch: {
			items: function (newVal, oldVal) {
				const index = sessionStorage.getItem(this.sessionKey);
				//console.log(this.items.length, index);

				if (this.items && index < this.items.length) {
					this.selectItem(this.items[index], index);
				}
			}
		},
		created: function () {
			this.sessionKey = 'nominow-searchable-menulist-' + document.location.pathname + '-' + this._uid;
		},
		methods: {
			selectItem: function (elem, ix) {
				this.selectedItem = elem;
				this.$emit('select-item', elem, ix);
				sessionStorage.setItem(this.sessionKey, ix);
			},
			filterList: function () {
				//console.log('filter', this.filter);
				const self = this;
				if (!self.filter || self.filter == '') {
					$('.' + this.cssclass).removeClass('is-hidden');
				} else {
					$('.' + this.cssclass).each(function () {
						const re = new RegExp(self.filter, 'gi');

						if (re.test($(this).text())) {
							$(this).removeClass('is-hidden');
						} else {
							$(this).addClass('is-hidden');
						}
					});
				}
			}
		}
	});
})();
